export {
  mapFhirAppointmentToModel,
  mapModelToFhirAppointment,
} from './mapping';
export type {
  Appointment,
  AppointmentGetAllRequest,
  AppointmentGetAllResponse,
} from './schema';
export {
  AppointmentGetAllRequestSchema,
  AppointmentGetAllResponseSchema,
  AppointmentSchema,
} from './schema';
